import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import axios from "axios";
import App from "./App";
import LandingReducer from "./Store/reducers/LandingReducer";
import AuthReducer from "./Store/reducers/AuthReducer";
import PreviewReducer from "./Store/reducers/PreviewReducer";
import EditPostReducer from "./Store/reducers/EditPostReducer";
import ActivityReducer from "./Store/reducers/ActivityReducer";
import MessagesReducer from "./Store/reducers/MessagesReducer";
import ChatReducer from "./Store/reducers/ChatReducer";
import BecomeFeaturedReducer from "./Store/reducers/BecomeFeatureReducer";
import TopUpReducer from "./Store/reducers/TopUpReducer";
import ProfileReducer from "./Store/reducers/ProfileReducer";
import AddServiceReducer from "./Store/reducers/addServiceReducer";
import RequiredFormReducer from "./Store/reducers/RequiredFormReducer";
import "./index.css";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const logger = (store) => {
  return (next) => {
    return (action) => {
      if (process.env.REACT_APP_ENV === "development")
        console.log("MiddlerWare", action);
      const result = next(action);
      if (process.env.REACT_APP_ENV === "development")
        console.log("MidlleWare-2", store.getState());
      return result;
    };
  };
};

const rootReducer = combineReducers({
  Auth: AuthReducer,
  Landing: LandingReducer,
  Preview: PreviewReducer,
  EditPost: EditPostReducer,
  Activity: ActivityReducer,
  Messages: MessagesReducer,
  Chat: ChatReducer,
  BecomeFeatured: BecomeFeaturedReducer,
  TopUp: TopUpReducer,
  Profile: ProfileReducer,
  AddService: AddServiceReducer,
  RequiredForm: RequiredFormReducer,
});

const store = createStore(rootReducer, compose(applyMiddleware(logger, thunk)));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastProvider placement="bottom-left">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
